<template>
  <div class="container is-fluid is-no-padding">

    <template v-if="!user.isNew">
    <div class="columns is-gapless">
      <div class="column is-3-tablet is-2-desktop secondarysidebar">
        <div class="sticky">
            <TagSideBar 
              :tags="tags"
              :selected-tag="selectedTag"
              @selectedTagChange="(tag) => tagSelectionChange(tag.name)"
            />
        </div>
      </div>
      <div
        class="column is-9-tablet is-10-desktop"
      >
        <TagEdit
          :existing-tags="tags"
          :editing-tag-name="selectedTag" 
          @tagDeleted="tagDeletionHandler" 
          @tagRenamed="tagRenamedHandler"
        />
        <template v-if="selectedTag">
          <BookmarksList
            :single-tag="selectedTag"
            @bookmarkChanged="loadAll"
          />
        </template>
      </div>
    </div>

    </template>
    <template v-else>
      <InfoPanel />
    </template>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import _ from 'lodash'
  import InfoPanel from '@/components/shared/InfoPanel.vue'
  import TagSideBar from '@/components/tags/TagSideBar.vue'
  import TagEdit from '@/components/tags/TagEdit.vue'
  import BookmarksList from '@/components/bookmarks/BookmarksList.vue'
  

  export default {
    name: 'Tags',
    components: {
      InfoPanel,
      BookmarksList,
      TagEdit,
      TagSideBar: TagSideBar
    },
    props: {
    },
    data: function() {
      return {
        selectedTag: ' ',
        tags: []
      }
    },
    computed: {
      ...mapGetters({ 
        allTags: 'tags/allUnsorted',
        user: 'auth/user',
        logged: 'auth/logged'
      }),
      selectedTags() {
        return this.$store.state.selectedTags
      }
    },
    beforeMount() { 
      this.loadAll();
    },
    mounted() {
      this.selectedTag  = this.$route.params.tag;

      if (this.user.isNew == true) {
        this.$store.dispatch('auth/reloadLogin')
      }
    },
    methods: {
      ...mapActions({
        loadAllPlusUntagged: 'tags/loadAllPlusUntagged'
      }),
      loadAll: async function(forceLoad = false){
        let _this = this;
        _this.tags.length=0;
        await this.loadAllPlusUntagged(forceLoad).then( () => {
          _this.tags.push(... _.sortBy(_this.allTags, function(item){ return item.name }));
        });
      },
      tagSelectionChange: function(tagName){
        this.selectedTag = tagName; 
        this.$router.push({name: 'EditTag', params: {tag: tagName}});
      },
      tagDeletionHandler: function(){
        this.selectedTag = ' '; 
        this.loadAll();
      },
      tagRenamedHandler: function(args){
        this.loadAll(true).then(() => this.tagSelectionChange(args.to));
      }
    }
  }
</script>

<style lang="scss" scoped>
.secondarysidebar.column{
  min-width: fit-content;
}

@media screen and (max-width: 768px) {
    .columns.is-gapless > .column.secondarysidebar {
        max-height: 20vh;
        min-height: 10em;
        overflow-y: auto;
      }
    }
</style>
